import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import * as analytics from '../../services/analytics';
import find from 'lodash/find';
import get from 'lodash/get';
import { Formik } from 'formik';
import * as yup from 'yup';
import US_STATES from '../../constants/usStates';

const propTypes = {
  client: PropTypes.object,
  onSubmit: PropTypes.func,
};

class BOAEnrollmentRegionView extends PureComponent {
  constructor(props) {
    super(props);
    this.formValidationSchema = yup.object().shape({
      region: yup
        .string()
        .notOneOf([''])
        .required(`Please select a state to continue.`),
    });
    this.state = {
      isInProgress: false,
      isValid: this.formValidationSchema.isValidSync(this.initialFormValues),
    };
  }

  componentDidMount() {
    analytics.page('BOA - Enrollment Business Region');
  }

  handleInitialValidation = ({ initialValues }) => {
    return this.formValidationSchema.isValidSync(initialValues);
  };

  handleSubmit = (values) => {
    const { updateQuote, onSubmit, onNotifyError, getPlans, quote, client } =
      this.props;
    const { region } = values;
    const regionTriple = find(US_STATES, (triple) => triple[0] === region);
    this.setState({
      isInProgress: true,
    });

    // XXX: Hardcoding country until Google Maps Autocomplete implemented
    if (client.person.address) {
      client.person.address.country = {
        code: 'US',
        name: 'United States',
      };
    }

    const policyholder = {
      ...client.person,
      position_on_policy: 1,
    };

    const existingRatingAddress = get(quote, 'application.rating_address');
    const doesRegionMatchBusinessAddress =
      get(existingRatingAddress, 'region.code') === regionTriple[0];

    const updatedQuote = {
      ...quote,
      application: {
        ...quote.application,
        client: {
          ...client.person,
          client_type: client.client_type,
        },
        holders: get(quote, 'application.holders')
          ? get(quote, 'application.holders')
          : [policyholder],
        rating_address: {
          ...(doesRegionMatchBusinessAddress
            ? existingRatingAddress
            : {
                region: {
                  code: regionTriple[0],
                  name: regionTriple[1],
                },
              }),
        },
      },
    };
    updateQuote(updatedQuote)
      .then((quote) => {
        return getPlans(quote.quote_number);
      })
      .then(onSubmit)
      .catch((error) => {
        this.setState({
          isInProgress: false,
        });
        onNotifyError(error);
      });
  };

  handleChange = (e) => {
    const { handleChange } = this.form;
    this.setState({
      isValid: this.formValidationSchema.isValidSync({
        region: e.target.value,
      }),
    });
    handleChange(e);
  };

  get initialFormValues() {
    const { client, quote } = this.props;
    const clientBusinessRegion =
      client && client.client_type === 'business'
        ? get(client, 'person.address.region.code')
        : null;
    const initialValue =
      get(quote, 'application.rating_address.region.code') ||
      clientBusinessRegion ||
      '';
    return {
      region: initialValue,
    };
  }

  get stateOptions() {
    return US_STATES.map(([code, label]) => (
      <option key={code} value={code}>
        {label}
      </option>
    ));
  }

  render() {
    return (
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-7 p-t-30">
            <h3 className="text-center semi-bold">
              In what state is the business headquartered?
            </h3>
            <div className="BOAEnrollmentRegionView-clientDetails card m-t-20">
              <div className="card-block">
                <div className="form-group">
                  <Formik
                    initialValues={this.initialFormValues}
                    isInitialValid={this.handleInitialValidation}
                    validationSchema={this.formValidationSchema}
                    onSubmit={this.handleSubmit}
                    innerRef={(c) => (this.form = c)}
                  >
                    {({ values, errors, touched, handleSubmit }) => {
                      return (
                        <form className="row" onSubmit={handleSubmit}>
                          <label className="col-md-3 text-uppercase">
                            Headquarters
                          </label>
                          <div className="col-md-9">
                            <label htmlFor="region" className="text-uppercase">
                              State
                            </label>
                            <select
                              className="form-control"
                              id="region"
                              name="region"
                              value={values.region || ''}
                              aria-required="true"
                              touched={touched.region ? 'true' : 'false'}
                              errors={errors.region}
                              onChange={this.handleChange}
                              disabled={this.state.isInProgress}
                            >
                              <option value="">Select one</option>
                              {this.stateOptions}
                            </select>
                          </div>
                          <input
                            type="submit"
                            style={{ display: 'none' }}
                            ref={(c) => (this.inputSubmit = c)}
                          />
                        </form>
                      );
                    }}
                  </Formik>
                </div>
              </div>
            </div>

            <div className="row justify-content-center">
              <button
                className="btn btn-lg btn-complete"
                disabled={!this.state.isValid || this.state.isInProgress}
                onClick={() => this.inputSubmit.click()}
                type="button"
              >
                Next
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

BOAEnrollmentRegionView.propTypes = propTypes;

export default BOAEnrollmentRegionView;
